<template>
  <el-dialog
    width="968px"
    custom-class="popConfirmContent"
    :title="`是否将以下联系人分配到${submitParmas.takeover_username || '--'}`"
    :visible.sync="dialogTableVisible"
    destroy-on-close
    :before-close="hidePop"
  >
    <div class="listContent">
      <el-table
        :data="submitParmas.customers"
        tooltip-effect="dark"
        style="width: 100%"
        header-row-class-name="headerClass"
        :header-cell-style="headerObj"
      >
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
        </template>
        <el-table-column prop="custom_name" label="客户名称"></el-table-column>
        <el-table-column prop="doctor_name" label="医生"></el-table-column>
        <el-table-column prop="hospital_name" label="医院" width="360"></el-table-column>
        <el-table-column prop="department_name" label="科室"></el-table-column>
        <el-table-column prop="principal_name" label="原负责人"></el-table-column>
        <el-table-column prop="" label="新负责人">
          <template slot-scope="">
            <span>{{ submitParmas.takeover_username }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hidePop">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  updateTransferOnjobCustomerApi,
  updateTransferResignCustomerApi,
} from '@/api/enterpriseWeChatManagement';
import NoData from '@/components/no-data';
export default {
  name: 'PopAllocation',
  components: {
    NoData,
  },
  props: {
    dialogTableVisible: {
      type: Boolean,
      default: false,
    },
    submitParmas: {
      type: Object,
      default: () => ({}),
    },
    ptype: {
      type: Number,
      default: 0,
    }, // 客户类型(0已分配客户 1待分配客户)
  },
  data() {
    return {
      headerObj: {
        background: '#f5f7fa',
      },
      tableData: [],
    };
  },
  watch: {
    // dialogTableVisible(val, nextVal) {
    //   // console.log(val);
    // },
  },
  created() {},
  methods: {
    hidePop() {
      this.$emit('hidePop');
    },
    async onSubmit() {
      try {
        this.ptype === 0
          ? await updateTransferOnjobCustomerApi(this.submitParmas)
          : await updateTransferResignCustomerApi(this.submitParmas);
        this.$message({
          message: '分配新负责人成功',
          type: 'success',
        });

        this.$emit('onSuccess');
      } catch (err) {
        this.$message.error(`${err.message || '操作失败'}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.popConfirmContent {
  .listContent {
    ::v-deep.pagination {
      text-align: right;
      margin: 10px 0;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
